import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NEVER, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  api = 'https://app.ostadvisit.com';
  // private tokenAPI = 'https://testmac.medis.land/'; // Replace with your API URL
  token: any;

  constructor(private http: HttpClient, private oidcSecurityService: OidcSecurityService) {}
  
  apiCall(method, route, body?, params?) {

    this.oidcSecurityService.getAccessToken().subscribe((token) => {
      this.token = token;
    });

    let httpParams = new HttpParams();

    if(params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }
    
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.token
    });

    if ( method === 'post' ) {
      return this.http.post(this.api + route, body, {headers, observe: 'response'}).pipe(
        catchError(error => {
          if(error.status == 401) {
            // this.oidcSecurityService.authorize();
          } else if (error.status == 403) {
            return NEVER;
          } else {
            console.log('ERROR:',error);
          }
          return of([]);
        })
      )
    } else if ( method === 'get') {
      return this.http.get(this.api + route, {headers, observe:'response', params:httpParams}).pipe(
        catchError(error => {
          if(error.status == 401){
            // this.oidcSecurityService.authorize();
          } else if (error.status == 403) {
            return NEVER;
          } else {
            console.log('ERROR:',error);
          }
          return of([]);
        })
      )
    } else if ( method === 'delete') {
      return this.http.delete(this.api + route, {headers, observe: 'response'}).pipe(
        catchError(error => {
          if (error.status == 401){
            return NEVER;
          } else {
            console.log('ERROR:',error);
          }
          return of([]);
        })
      )
    } else if ( method === 'put') {
      return this.http.put(this.api + route, body, { headers ,observe:'response'}).pipe(
        catchError (error => {
          // console.log(error);
          
          if(error.status == 401){
            return NEVER;
          } else {
            console.log('ERROR:',error);
          }
          return of([]);          
        })
      )
    }

  }

  callFormDataApi(route, formData) {
    const headers= new HttpHeaders({
      'encrypt': 'multipart/form-data',
      Authorization: 'Bearer ' + this.token
    });
    return this.http.post(this.api + route , formData ,  
      {headers, observe: 'response'}).pipe(
      catchError(error => {
        console.log(error);
        
        // if (error.status == 403) {
        //   this.router.navigate(['']);
          
        // }
        return of([]);
      })
    )
  } 


}
